module.exports = __webpack_public_path__ + "img/Group.1dddeec4.svg";